var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "new_top_tools" }, [
    _c(
      "div",
      { staticClass: "ntt_main" },
      [
        !_vm.isIndex
          ? _c(
              "router-link",
              { staticClass: "nttm_goindex", attrs: { to: "/" } },
              [_vm._v("网站首页")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass: "nttm_gywm",
            attrs: { title: "关于我们", to: "/about" }
          },
          [_vm._v("关于我们")]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass: "nttm_xsbz",
            attrs: { title: "新手帮助", to: "/help" }
          },
          [_vm._v("新手帮助")]
        ),
        _vm._v(" "),
        _vm.userInfo
          ? _c(
              "a",
              {
                staticClass: "nttm_exit",
                attrs: { href: "javascript:" },
                on: { click: _vm.logout }
              },
              [_vm._v("退出")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.userInfo
          ? _c("div", { staticClass: "nttm_user" }, [
              _vm._v(_vm._s(_vm.userInfo.realName) + "\n      "),
              _c("div", { staticClass: "nttm_user_disk" }, [
                _c("div", { staticClass: "nttmud_head" }, [
                  _c("img", { attrs: { src: _vm.userInfo.imageUrl } })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "nttmud_info" }, [
                  _c("p", { staticClass: "textover" }, [
                    _vm._v(_vm._s(_vm.userInfo.realName))
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.userInfo.company.companyName))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clear" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "nttmud_a" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            path: "/EditUser",
                            query: { baseVisible: true }
                          }
                        }
                      },
                      [_vm._v("帐号设置")]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: { path: "/EditUser", query: { pwdVisible: true } }
                        }
                      },
                      [_vm._v("修改密码")]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      { attrs: { title: "我的培训", to: "/usercenter" } },
                      [_vm._v("我的培训")]
                    )
                  ],
                  1
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "nttm_telNum" }, [_vm._v("400-822-2055")])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-611a6976", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-611a6976","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shortcut.vue
// module id = null
// module chunks = 